module.exports = __webpack_public_path__ + "assets/img/desc-04-fdc6baf6.png";